import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <footer
            data-testid="footer-marquee-strip"
            className="z-20 flex h-10 shrink-0 items-center overflow-hidden border-t border-slate-800 bg-slate-900 sm:h-12"
        >
            <div className="animate-marquee flex w-max items-center">
                {items.map((item, i) => (
                    <div key={i} className="flex items-center">
                        <span className="whitespace-nowrap px-8 font-mono2 text-[10px] sm:text-xs font-medium uppercase tracking-[0.25em] text-slate-300">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rounded-full bg-teal-500/80" />
                    </div>
                ))}
            </div>
        </footer>
    );
};
